import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    refDiv: {
      display: 'flex',
      flexGrow: 1,
    },
    refDivIsMenuListed: {
      overflow: 'hidden',
    },
    listIsMenuListed: {
      direction: 'rtl',
    },
    list: {
      overflowY: 'auto',
      marginLeft: '20px',
      '&::-webkit-scrollbar': {
        width: '3px',
      },
    },
    tableContainerIsMenuListed: {
      direction: 'ltr',
    },
    cell: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      paddingLeft: 0,
      borderBottom: 'none',
      maxWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    cellIcon: {
      marginTop: 'auto',
      marginBottom: 'auto',
      padding: 0,
      borderBottom: 'none',
    },
    head: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    headCellIcon: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
    icon: {
      height: '20px',
    },
    iconContainer: {
      height: '20px',
      marginRight: '8px',
      cursor: 'pointer',
    },
    tableContainer: {
      overflow: 'hidden',
    },
    isMenuListed: {
      color: 'inherit',
      textDecoration: 'none',
      display: 'flex',
      height: '40px',
    },
    isMenuListedCell: {
      paddingLeft: '20px',
    },
  };
};
